import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldCodeComponent } from './field-code.component';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    FieldCodeComponent
  ],
  exports: [
    FieldCodeComponent
  ],
  imports: [
    CommonModule,
    CodemirrorModule,
    FormsModule
  ]
})
export class FieldCodeModule { }
